export interface ICurrentAppService {
    getNativeAppMode(): boolean;
    getIsWalleeSdkAvailable(): boolean | undefined;
}

export class CurrentAppService {
    private static instance: ICurrentAppService;

    public static init(currentIdentityService: ICurrentAppService) {
        CurrentAppService.instance = currentIdentityService;
    }

    public static getNativeAppMode(): boolean {
        const nativeAppMode = CurrentAppService.instance?.getNativeAppMode();
        return nativeAppMode ?? false;
    }

    public static getIsWalleeSdkAvailable(): boolean {
        const isWalleeSdkAvailable = CurrentAppService.instance?.getIsWalleeSdkAvailable();
        return isWalleeSdkAvailable ?? false;
    }
}
